export function paymentRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_PAYMENT_START":           
        case "FETCH_PAYMENTS_START":                                 
        case "UPDATE_PAYMENT_START":                                 
        case "DELETE_PAYMENT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_PAYMENT_FULFILLED":           
        case "FETCH_PAYMENTS_FULFILLED":                                 
        case "UPDATE_PAYMENT_FULFILLED":                                 
        case "DELETE_PAYMENT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_PAYMENT_ERROR":
        case "FETCH_PAYMENTS_ERROR":
        case "UPDATE_PAYMENT_ERROR":
        case "DELETE_PAYMENT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}